import { Route, Routes } from "react-router";
import InvoicesListPage from "./list";
import InvoiceViewPage from "./view";

function InvoicesPage() {
	return (
		<Routes>
			<Route path="/" element={<InvoicesListPage />} />
			<Route path="/:id" element={<InvoiceViewPage />} />
		</Routes>
	);
}

export default InvoicesPage;
